import { MoiCommentModel } from "./moi-comment-model";
import { MoiCommentEditorConfig } from "./moi-comment-editor-config";

export class MoiCommentEditorParameters {
    moiGuid: string;
    comment: MoiCommentModel;

    config: MoiCommentEditorConfig;
}